import { post } from 'models/shared/helpers/axiosInstance';
import {
	IncodeResultsResponse,
	IncodeSessionResponse,
} from '../interfaces/incode.interface';
import { IncodeSessionStatus } from '../enums/incode.enums';

const baseIncodePath = '/v1/incode';

export const retrieveIncodeResults = async (
	formId: string,
): Promise<IncodeResultsResponse> => {
	try {
		const res = await post<IncodeResultsResponse>(
			`${baseIncodePath}/${formId}/results`,
			{},
		);
		if (res.data.status === IncodeSessionStatus.created) {
			throw Error('La sesión de incode aun no ha teminado');
		}
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};

export const createIncodeSession = async (
	formId: string,
): Promise<IncodeSessionResponse> => {
	try {
		const res = await post<IncodeSessionResponse>(
			`${baseIncodePath}/${formId}/session`,
			{},
		);
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};
